<div class="button" [class.button--spacing]="!isTabsButton">
  <button pButton pRipple class="action" (click)="buttonClicked.emit()">
    <i class="pi pi-plus"></i>
    <span>{{ label() }}</span>
  </button>
</div>
